"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAbcStore = void 0;
const pinia_1 = require("pinia");
exports.useAbcStore = (0, pinia_1.defineStore)("abc", {
    state() {
        return {
            data: null,
            insurers: [],
            insurer: null,
            plazo: 24,
            engancheAmount: 0,
            enganchePercentage: 0,
        };
    },
    actions: {},
});
